import { useState } from 'react';
import styles from './styles.module.scss';

import CreateProduct from './CreateProduct/CreateProduct';
import Overview from './Overview/Overview';
import EditProduct from './EditProduct/EditProduct';

export default function Products() {

  const [managementType, setManagementType] = useState('Overview');
  const [editProduct, setEditProduct] = useState(null);

  return (
    <section id={styles.productWrapper}>
      <div id={styles.container}>
        { managementType === 'Overview' && <Overview openCreateProduct={() => setManagementType('Create')} openEditProduct={(prodID) => { setEditProduct(prodID); setManagementType('Edit'); }} /> }
        { managementType === 'Create' && <CreateProduct close={() => setManagementType('Overview')} /> }
        { managementType === 'Edit' && editProduct && <EditProduct productID={editProduct} close={() => { setEditProduct(null); setManagementType('Overview') } } /> }
      </div>
    </section>
  );
}
